if (!customElements.get('product-discount-offer')) {
  customElements.define(
    'product-discount-offer',
    class ProductDiscountOffer extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        this.unsubscribeVariantChange?.();
        window.clearTimeout(this.copyButtonTimeout);
      }

      handleVariantChange = ({ data }) => {
        const variantId = data?.variant?.id;
        if (!variantId || String(variantId) === this.dataset.currentVariantId) return;

        const template = this.querySelector(`template[data-discount-offer-variant="${variantId}"]`);
        const current = this.querySelector('[data-discount-offer-current]');
        if (!template || !current) return;

        current.innerHTML = template.innerHTML;
        this.dataset.currentVariantId = String(variantId);
      };

      handleClick = async (event) => {
        const termsButton = event.target.closest('[data-discount-terms]');
        this.querySelectorAll('.product-discount-offer__terms-wrap.is-open').forEach((wrapper) => {
          if (!termsButton || !wrapper.contains(termsButton)) {
            wrapper.classList.remove('is-open');
            wrapper.querySelector('[data-discount-terms]')?.setAttribute('aria-expanded', 'false');
          }
        });

        if (termsButton && this.contains(termsButton)) {
          const wrapper = termsButton.closest('.product-discount-offer__terms-wrap');
          const isOpen = wrapper.classList.toggle('is-open');
          termsButton.setAttribute('aria-expanded', String(isOpen));
          return;
        }

        const button = event.target.closest('[data-discount-copy]');
        if (!button || !this.contains(button)) return;

        try {
          await this.copyCode(button.dataset.code);
          this.showCopiedButtonState(button);
          this.showCopyToast(button.dataset.copiedLabel);
        } catch (error) {
          console.error('Unable to copy discount code.', error);
        }
      };

      handleKeydown = (event) => {
        if (event.key !== 'Escape') return;

        this.querySelectorAll('.product-discount-offer__terms-wrap.is-open').forEach((wrapper) => {
          wrapper.classList.remove('is-open');
          wrapper.querySelector('[data-discount-terms]')?.setAttribute('aria-expanded', 'false');
        });
      };

      async copyCode(code) {
        if (navigator.clipboard?.writeText) {
          try {
            await navigator.clipboard.writeText(code);
            return;
          } catch (error) {
            // Theme previews and some browsers block the Clipboard API; use the DOM fallback below.
          }
        }

        const textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();
        if (!copied) throw new Error('Copy command failed.');
      }

      showCopiedButtonState(button) {
        const label = button.querySelector('[data-discount-cta-label]');
        if (!label) return;

        window.clearTimeout(this.copyButtonTimeout);
        const originalLabel = label.textContent;
        label.textContent = button.dataset.copiedButtonLabel;
        this.copyButtonTimeout = window.setTimeout(() => {
          label.textContent = originalLabel;
        }, 2400);
      }

      showCopyToast(message) {
        let toast = document.querySelector('[data-global-discount-copy-toast]');
        if (!toast) {
          toast = document.createElement('div');
          toast.className = 'product-discount-offer__toast';
          toast.dataset.globalDiscountCopyToast = '';
          toast.setAttribute('role', 'status');
          toast.setAttribute('aria-live', 'polite');
          document.body.appendChild(toast);
        }

        window.clearTimeout(toast.showTimeout);
        window.clearTimeout(toast.hideTimeout);
        toast.textContent = message;
        toast.hidden = false;
        requestAnimationFrame(() => toast.classList.add('is-visible'));

        toast.showTimeout = window.setTimeout(() => {
          toast.classList.remove('is-visible');
          toast.hideTimeout = window.setTimeout(() => {
            toast.hidden = true;
          }, 150);
        }, 2400);
      }
    }
  );
}
